import React from 'react';

import styled from '@emotion/styled';

import CurrencyOnlyInputField from '../../../components/FormCom/CurrencyOnlyInputField';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import {
  LookupPriceInitialValues,
  LookupPriceSchema,
} from '../../../models/dashboard/revenue/lookup-price';
import { createPriceManagementActions } from '../../../redux/slices/priceManagementSlice';
import { useAppDisPatch, useAppSelector } from '../../../redux/store';
import { formatNaira } from '../../../utils/utils';

const PayAsYouGoForm = () => {
  const dispatch = useAppDisPatch();
  const handleOnSubmit = () => {};
  const { currentConfigData } = useAppSelector(
    (state) => state.currentConfigData,
  );

  const handleTripLogFieldChange = (price: string) => {
    dispatch(createPriceManagementActions.setPayAsYouGoPrice({ price }));
  };

  return (
    <Container>
      <Label>Pay-As-You-Go Pricing</Label>

      <PayAsYouGoFormBox>
        <FormComponent
          initialValues={LookupPriceInitialValues}
          schema={LookupPriceSchema}
          onSubmit={handleOnSubmit}
        >
          <CurrencyOnlyInputField
            // showErrorLabel={false}
            label='Price per Lookup'
            name='price'
            id='price'
            type='text'
            placeholder='Price'
            onValueChange={(value) => handleTripLogFieldChange(value)}
          />
          <InputFieldFooter>
            This price will be charged to users for each lookup service request
          </InputFieldFooter>
        </FormComponent>

        <PayAsYouGoPricePreviewer>
          <PriceLabel>Current Price</PriceLabel>
          <PreviewAmount>
            {formatNaira(currentConfigData?.unitPrice ?? 0)}
          </PreviewAmount>
        </PayAsYouGoPricePreviewer>
      </PayAsYouGoFormBox>
    </Container>
  );
};

export default PayAsYouGoForm;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const Label = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
  color: #5c5963;
`;

const PayAsYouGoFormBox = styled.div`
  background: rgba(91, 145, 245, 0.02);
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: 12px;
  width: 100%;
  padding: 20px;
  display: flex;
  gap: 60px;
`;

const InputFieldFooter = styled.div`
  font-size: 12px;
  font-weight: 400;
  margin-top: -20px;
  color: #9ca3af;
`;

const PayAsYouGoPricePreviewer = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  border-radius: 12px;
  padding: 22px;
  background-color: white;
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
`;

const PriceLabel = styled.div`
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
`;

const PreviewAmount = styled.div`
  font-size: 22px;
  color: #6b7280;
  font-weight: 800;
`;
